module.exports = __webpack_public_path__ + "static/media/find-us-on-play-store.6a73d314.png";